<template>
  <div>
    <section class="all-categories-side bg-white  text-right">
      <div
        class="d-flex align-items-baseline justify-content-between card-body  title-box-modal"
      >
        <button class="text-color-666" @click="backChildMenu">
          <span v-if="childMenu">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m14.475 12l-7.35-7.35q-.375-.375-.363-.888t.388-.887t.888-.375t.887.375l7.675 7.7q.3.3.45.675t.15.75t-.15.75t-.45.675l-7.7 7.7q-.375.375-.875.363T7.15 21.1t-.375-.888t.375-.887z"
              />
            </svg>
          </span>
        </button>
        <h2 class="title-modal">{{ title }}</h2>
        <!-- <router-link to="/" class="mr-3"><img class="menu-logo" style="max-width: 160px;width: 100px" src="@/assets/images/logo.png" alt="benedito"></router-link> -->
        <button
          type="button"
          class="bg-none weight-bold text-color-666 rounded"
          @click="allCategoriesToggle()"
        >
          <CloseSvg width="24" />
        </button>
      </div>
      <div class="accordion pb-5  border-radius15" id="accordionExample">
        <!-- <div v-for="item in menu" :key="item.id"  class="card"> -->
        <!-- <div class="card-header my-1 pr-3 d-flex justify-content-between" id="headingOne" >
            <a
                v-if="item.new_tab || item.link"
                :target="item.new_tab ? '_blank' : '_self'"
                :href="$router.resolve(findUrl(
                      item.linkable_type,
                      item.linkable_id,
                      item.slug, item.link)).href"
                @click="close" class="d-flex my-auto text-color-444  font-weight-bold">
              <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
              {{item.title}} </a>
            <router-link v-else @click.native="close"
                         class="d-flex my-auto text-color-444  font-weight-bold"
                         :to="$router.resolve(findUrl(item.linkable_type, item.linkable_id, item.slug, item.link)).href">
              <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
              {{item.title}}
            </router-link>
            <button v-show="item.children.length!=0" @click="(e) => rotateArrow(e.currentTarget)"
                    class="all-categories-side-btn with-event collapsed" type="button" data-toggle="collapse"
                    :data-target="'#mobileMenuChild'+item.id" aria-expanded="true" aria-controls="collapseOne" >
              <svg
                  class="svg1"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    stroke="#444"
                    stroke-width="3"
                    d="M16.2559 4.24279C16.5805 4.56431 16.5827 5.08555 16.2537 5.40707L11.3882 10.1717L11.3023 10.2451C10.9734 10.4897 10.5033 10.4642 10.2048 10.1684C10.043 10.0082 9.96049 9.79753 9.96049 9.58794C9.96049 9.37725 10.043 9.16546 10.207 9.00525L15.0724 4.2395L15.1584 4.16609C15.4873 3.92149 15.9573 3.94706 16.2559 4.24279ZM16.3291 18.6783C16.5802 19.001 16.5535 19.4636 16.256 19.7583C15.9303 20.0798 15.4005 20.0809 15.0725 19.7594L7.74651 12.5828L7.67131 12.4987C7.55732 12.3523 7.5 12.1766 7.5 12.0001C7.5 11.7905 7.58254 11.5798 7.74428 11.4196C8.06998 11.097 8.5998 11.0959 8.92773 11.4174L16.2538 18.594L16.3291 18.6783Z"
                />
              </svg>
              <svg
                  class="svg2 d-none"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M19 8.5L12 15.5L5 8.5"
                    stroke="#444"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
              </svg>
            </button>

          </div> -->

        <!-- <div  v-show="item.children.length!=0" :id="'mobileMenuChild'+item.id" class="sub-all-categories-side-btn text-right collapse" aria-labelledby="headingOne" data-parent="#accordionExample"> -->
        <div class="card-body mt-4 py-0">
          <childrenMenu
            v-if="childMenu"
            :childMenuItem="childMenuItem"
            @closeMenu="closeMenu"
          />

          <nav class="" v-else>
            <ul class="grid-menu" v-if="menu && menu.length">
              <template v-if="menu[0]&&menu[0].children.length">

                <li
                  v-for="item in menu[0].children"
                  :key="item?.id"
                  class="item-menu"
                >
                  <button
                    class="btn-menu card"
                    v-if="item?.children?.length"
                    @click="showChildMenu(item)"
                  >
                    <figure>
                      <img :src="item?.icon?.url ?? ''" alt="" />
                    </figure>
                    <h3 class="title-card">
                      {{ item?.title ?? "" }}
                    </h3>
                  </button>
                  <template v-else>
                    <a
                      v-if="item?.new_tab || item?.link"
                      :target="item.new_tab ? '_blank' : '_self'"
                      :href="
                        $router.resolve(
                          findUrl(
                            item?.linkable_type,
                            item?.linkable_id,
                            item?.slug,
                            item?.link
                          )
                        ).href
                      "
                      @click="close"
                      class="w-100 link-menu card"
                    >
                      <figure>
                        <img :src="item?.icon?.url ?? ''" alt="" />
                      </figure>
                      <h3 class="title-card">
                        {{ item?.title ?? "" }}
                      </h3>
                    </a>
                    <router-link
                      v-else
                      @click.native="close"
                      :to="
                        $router.resolve(
                          findUrl(
                            item?.linkable_type,
                            item?.linkable_id,
                            item?.slug,
                            item?.link
                          )
                        ).href
                      "
                      class="link-menu w-100 card"
                    >
                      <figure>
                        <img :src="item?.icon?.url ?? ''" alt="" />
                      </figure>
                      <h3 class="title-card">
                        {{ item?.title ?? "" }}
                      </h3>
                    </router-link>
                  </template>
                </li>
              </template>
              <template v-if="menu.length>1">

                <li 
                  v-for="(item,index) in menu.slice(1)"
                  :key="item.id"
                  class="item-menu"
                  :class="{'end-cart':(((menu.length-1)+menu[0].children.length)%2==1 && ((index+1) == (menu.length-1)))}"
                >
                
                  <button
                    class="btn-menu card"
                    v-if="item.children.length"
                    @click="showChildMenu(item)"
                  >
                    <figure>
                      <img :src="item?.icon?.url ?? ''" alt="" />
                    </figure>
                    <h3 class="title-card">
                      {{ item?.title ?? "" }}
                    </h3>
                  </button>
                  <template v-else>
                    <a
                      v-if="item?.new_tab || item?.link"
                      :target="item.new_tab ? '_blank' : '_self'"
                      :href="
                        $router.resolve(
                          findUrl(
                            item?.linkable_type,
                            item?.linkable_id,
                            item?.slug,
                            item?.link
                          )
                        ).href
                      "
                      @click="close"
                      class="w-100 link-menu card"
                    >
                      <figure>
                        <img :src="item?.icon?.url ?? ''" alt="" />
                      </figure>
                      <h3 class="title-card">
                        
                        {{ item?.title ?? "" }}
                      </h3>
                    </a>
                    <router-link
                      v-else
                      @click.native="close"
                      :to="
                        $router.resolve(
                          findUrl(
                            item?.linkable_type,
                            item?.linkable_id,
                            item?.slug,
                            item?.link
                          )
                        ).href
                      "
                      class="link-menu w-100 card"
                    >
                      <figure>
                        <img :src="item?.icon?.url ?? ''" alt="" />
                      </figure>
                      <h3 class="title-card">
                        {{ item?.title ?? "" }}
                      </h3>
                    </router-link>
                  </template>
                </li>
              </template>
              
            </ul>
          </nav>
        </div>
      </div>
      <!-- </div> -->

      <!-- </div> -->
    </section>
    <div class="all-categories-resp" @click="allCategoriesToggle()"></div>
  </div>
</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";
import CloseSvg from "@/components/svgs/CloseSvg";
import childrenMenu from "./mobileMenu/children.vue";
export default {
  name: "RespMenu",
  components: { CloseSvg, childrenMenu },
  watch: {},
  data() {
    return {
      childMenu: false,
      childMenuItem: null,
      title: "دسته بندی ها",
    };
  },
  methods: {
    showChildMenu(item) {
      this.childMenuItem = item;
      this.childMenu = true;
      this.title = item.title;

      console.log(this.childMenu, "this.childMenu");
    },
    gotoCategoryAndClose(id, slug) {
      this.$router.push({
        name: "product.category",
        params: { category: id, slug: slug },
      });
      this.allCategoriesToggle();
    },
    backChildMenu() {
      this.childMenuItem = null;
      this.childMenu = false;
      this.title = "دسته بندی ها";
    },
    closeMenu() {
      setTimeout(() => {
        let hasClassClose = document
          .getElementById("all-categories")
          .classList.contains("all-categories-close");
        if (hasClassClose) {
          this.allCategoriesToggle();
          this.childMenuItem = null;
          this.childMenu = false;
          this.title = "دسته بندی ها";
        }
      }, 200);
    },
    close() {
      setTimeout(() => {
        let hasClassClose = document
          .getElementById("all-categories")
          .classList.contains("all-categories-close");
        if (hasClassClose) {
          this.allCategoriesToggle();
        }
      }, 200);
    },
    findUrl,
    allCategoriesToggle() {
      this.childMenu = false;

      document
        .getElementById("all-categories")
        .classList.toggle("all-categories-close");
      let hasClassClose = document
        .getElementById("all-categories")
        .classList.contains("all-categories-close");
      let catSide = document.getElementsByClassName("all-categories-side")[0];
      let allCategoriesResp = document.querySelectorAll(
        ".all-categories-resp"
      )[0];

      // let wrapper = document.getElementsByClassName('wrapper')[0];
      if (hasClassClose) {
        window.addEventListener("popstate", this.checkBackButton);
        this.$router.push(this.$route.fullPath + "#resp-menu");
        catSide.style.right = "0px";
        allCategoriesResp.style.display = "block";
        // if(window.screen.width >= 1200){
        // wrapper.style.paddingRight="250px";
        // }
      } else {
        // if(window.screen.width >= 1200){
        //     wrapper.style.paddingRight="0";
        // }
        catSide.style.right = "-103%";
        allCategoriesResp.style.display = "none";
        this.$router
          .replace(this.$route.fullPath.replace("#resp-menu", ""))
          .catch((e) => {});
        window.removeEventListener("popstate", this.checkBackButton);
      }
    },
    rotateArrow(el) {
      el.children.forEach((child) => {
        if (child.classList.contains("d-none")) {
          child.classList.remove("d-none");
        } else {
          child.classList.add("d-none");
        }
      });
    },
    checkBackButton() {
      this.allCategoriesToggle();
    },
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener("popstate", this.checkBackButton);
  },
  computed: {
    // دریافت منو ها از ویو ایکس
    menu() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return this.$store.getters["front/getHomeData"];
      } else {
        return this.$store.getters["front/getHomeData"].menu.header;
      }
    },
    // دریافت دسته بندی ها ازویوایکس
    category() {
      if (this.$store.getters["front/getCategories"] == null) {
        return this.$store.getters["front/getCategories"];
      } else {
        return null;
      }
    },
  },
};
</script>
<style scoped>
/* .all-categories-side .all-categories-side-btn {
  flex-grow: 100;
  justify-content: flex-end;
  display: flex;
}


.all-categories-sub-menu > li {
  margin-bottom: 11px;
} */
button {
  background-color: unset;
}
.title-box-modal{
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  padding-block: 1rem;
}
.title-modal {
  font-size: 1rem;
  margin: 0;
}

.grid-menu {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 0 0px 1rem;
  list-style-type: none;
}
.item-menu {
  width: 100%;
  border: 1px solid #d4d4d4;
  border-radius: 0.25rem;
  display: flex;
  background-color: #fff;
  overflow: hidden;
}
.title-card {
  font-size: 13px;
  color: #000;
}
figure {
  margin: 0;
}
.btn-menu,
.link-menu {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.grid-menu .end-cart {
  grid-column: 1/2 span;
}
.btn-menu img,
.link-menu img {
  width: 45px;
}
.all-categories-side {
  width: 85%;
  z-index: 9999;
}
.all-categories-resp {
  z-index: 9998;
}
</style>
